import { render, staticRenderFns } from "./TaxLocation.vue?vue&type=template&id=7cf9834d"
import script from "./TaxLocation.vue?vue&type=script&lang=js"
export * from "./TaxLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TaxLocation.vue"
export default component.exports